import {Component, input, ChangeDetectionStrategy} from "@angular/core"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-section-content",
    templateUrl: "./section-content.component.html",
    styleUrls: ["./section-content.component.scss"],
})
export class SectionContentComponent {
    readonly $indent = input(true, {alias: "indent"})
}
